"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconDj = Experimental__IconDj;
exports.IconDj = IconDj;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconDj/index.tsx)
 */
function IconDj(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M7.813 14.497A6.5 6.5 0 0 1 1.5 8.016c.008-3.553 2.71-5.744 5.043-6.078.85-.121 1.288.037 1.564.246.312.238.553.639.822 1.276.077.184.156.386.239.602.451 1.167 1.05 2.717 2.505 3.81 1.01.76 1.46 1.529 1.592 2.209.13.679-.037 1.375-.468 2.03-.88 1.34-2.793 2.388-4.844 2.388-.046 0-.093 0-.14-.002Zm-.037 1.5A8 8 0 1 0 0 8.032c0 4.34 3.464 7.87 7.776 7.965Zm6.666-7.124c-.358-.788-.979-1.532-1.868-2.2-1.082-.813-1.51-1.9-1.967-3.06a30.59 30.59 0 0 0-.296-.736 6.285 6.285 0 0 0-.605-1.151 6.529 6.529 0 0 1 4.39 4.01 6.485 6.485 0 0 1 .346 3.137Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M11.74 20.997A9 9 0 0 1 3 12.022c.011-4.92 3.754-7.955 6.986-8.417 1.178-.169 1.792.05 2.183.346.438.333.774.894 1.144 1.773.108.256.216.536.332.834.622 1.61 1.444 3.737 3.443 5.239 1.398 1.05 2.026 2.118 2.208 3.066.183.948-.052 1.917-.65 2.827-1.22 1.858-3.87 3.31-6.71 3.31l-.195-.003Zm-.05 2c.103.002.207.003.31.003 6.076 0 11-4.924 11-11a10.98 10.98 0 0 0-2.47-6.947 11.04 11.04 0 0 0-3.61-2.894A10.958 10.958 0 0 0 12 1C5.925 1 1 5.925 1 12a8.067 8.067 0 0 0 0 .045c0 5.966 4.762 10.82 10.69 10.951Zm9.213-9.666c-.482-1.123-1.35-2.183-2.614-3.133-1.502-1.128-2.096-2.64-2.726-4.24a42.677 42.677 0 0 0-.407-1.01c-.234-.556-.51-1.138-.886-1.66.613.16 1.2.381 1.754.659a9.04 9.04 0 0 1 4.417 4.92 9.075 9.075 0 0 1 .463 4.464Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconDj is deprecated and will be archived soon. Use IconDj instead.
 */
function Experimental__IconDj(props) {
  return /*#__PURE__*/_react["default"].createElement(IconDj, props);
}